import BandFilesSection from './BandFilesSection';
import VenueFilesSection from './VenueFilesSection';
import { useTranslation } from 'react-i18next';
import { withCardIcon } from '../lib/uiIcons';
import type { VenueDTO } from '../api';

/**
 * FilesTab — the "Files" tab of the Show detail page: band-level show files and,
 * when a venue is chosen, the venue's files (route maps, venue plans, contracts).
 *
 * Extracted from ShowDetailPage (2026-08-14, Vague 3 pass 6).
 *
 * Roadcase (P4c): chrome harmonised to the `.rc-*` language — `.rc-card-head`
 * + mono uppercase `.rc-header-title` (+ `.rc-header-sub`), the venue block is
 * a `.rc-section-title` sub-heading. The two mounted sections
 * (BandFilesSection / VenueFilesSection — upload/download + writeGate) are
 * byte-identical to their pre-P4c state: only the chrome AROUND them belongs
 * to this lot. Their file table scrolls inside this tab's own
 * `overflow-x: auto` frame instead of widening the page at 390 (one markup,
 * no horizontal scrollbar).
 */
export interface FilesTabProps {
  bandId: string;
  showId: number;
  venueId: string | undefined;
  venues: VenueDTO[];
}

export default function FilesTab({ bandId, showId, venueId, venues }: FilesTabProps) {
  const { t } = useTranslation();
  return (
    <div className="card" data-files-tab style={{ maxWidth: 1000, marginBottom: 20 }}>
      <div className="rc-card-head">
        <div>
          <h3 className="rc-header-title">{withCardIcon('show-files:files', t('files.title'))}</h3>
          <p className="rc-header-sub">{t('files.hint')}</p>
        </div>
      </div>
      <div data-files="band" style={{ maxWidth: '100%', overflowX: 'auto' }}>
        <BandFilesSection bandId={bandId} showId={showId} description={t('files.bandDescription')} />
      </div>
      {venueId && (
        <div data-files="venue" style={{ marginTop: 16, maxWidth: '100%', overflowX: 'auto' }}>
          <h4 className="rc-section-title" style={{ margin: '0 0 8px' }}>{t('files.venueFiles', { name: venues.find((v) => String(v.id) === String(venueId))?.name || '' })}</h4>
          <VenueFilesSection venueId={venueId} />
        </div>
      )}
    </div>
  );
}
